import {Ingrediente} from "./Ingrediente";

export class IngredientePiatto {
    private _ingrediente: Ingrediente;
    private _obbligatorio: boolean;
    private _showMenu: boolean;
    private _quantita: number;
    private _quantitaTipo: string;

    constructor(_ingrediente: Ingrediente, _obbligatorio: boolean, _showMenu: boolean, _quantita: number, _quantitaTipo: string) {
        this._ingrediente = _ingrediente;
        this._obbligatorio = _obbligatorio;
        this._showMenu = _showMenu;
        this._quantita = _quantita;
        this._quantitaTipo = _quantitaTipo;
    }

    static async convertFromFirestore(data: any) {
        let ingredientePiatto = this.createEmpty();
        ingredientePiatto.showMenu = data.showMenu;
        ingredientePiatto.obbligatorio = data.obbligatorio;
        ingredientePiatto.quantita = data.quantita ?? 0;
        ingredientePiatto.quantitaTipo = data.quantita_tipo;
        let ingredienteReference = await data.ingrediente_reference.get();
        ingredientePiatto.ingrediente = await Ingrediente.convertFromFirestore(data.id, await ingredienteReference.data());
        ingredientePiatto.ingrediente.id = ingredienteReference.id;
        return ingredientePiatto;
    }

    static createEmpty() {
        return new IngredientePiatto(Ingrediente.createEmpty(), false, false, 0, "");
    }

    get ingrediente(): Ingrediente {
        return this._ingrediente;
    }

    set ingrediente(value: Ingrediente) {
        this._ingrediente = value;
    }

    get obbligatorio(): boolean {
        return this._obbligatorio;
    }

    set obbligatorio(value: boolean) {
        this._obbligatorio = value;
    }

    get showMenu(): boolean {
        return this._showMenu;
    }

    set showMenu(value: boolean) {
        this._showMenu = value;
    }

    get quantita(): number {
        return this._quantita;
    }

    set quantita(value: number) {
        this._quantita = value;
    }

    get quantitaTipo(): string {
        return this._quantitaTipo;
    }

    set quantitaTipo(value: string) {
        this._quantitaTipo = value;
    }
}